import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import DropDownField from "../../../Shared/DropdownField";
import { TICKET_TASK_FILTERS } from "../../../constants/TicketTaskFilter";
import { setTicketTaskAllFilters } from "../../../store/reducers/TicketTaskFilter";
import {
  setTeam,
  setType,
  setUserEmail,
  setUserName,
  setStatusDays,
  setStatus,
  setQuickSearch,
  setCurrentTab,
} from "../../../store/reducers/SharedLayoutDataSlice";
import { DASHBOARD_FILTERS } from "../../../constants/DashboardFilter";
import { DisplayMsg } from "../../../services/toastService";
import { BASE_HANDLER_URL } from "../../../handlers";

const QuickFilter = () => {
  const dispatch = useDispatch();
  const sharedData = useSelector((state) => state.SharedLayoutData);

  const searchFilter = {
    assignee: sharedData.DashboardUserEmail,
    team: sharedData.DashboardTeam,
    type: sharedData.DashboardType,
    status: sharedData.DashboardStatus,
    statusDays: sharedData.DashboardStatusDays,
    followDays: sharedData.DashboardFollowDays,
  };

  const userInfo = {
    text: sharedData.DashboardUserName,
    value: sharedData.DashboardUserEmail,
  };

  const dropDowData = useSelector((store) => store.DropdownList);
  const [Count, setCount] = useState({
    todayCount: 0,
    overDueCount: 0,
    statusCount: "0",
    followUpCount: "0",
    responseTime: "",
    resolvingTime: "",
  });
  const [FilterData, setFilterData] = useState({
    assigneeValue: userInfo.text === "" ? null : userInfo,
    assigneeName: "",
    teamValue: searchFilter.team,
    teamEmail: "",
    teamName: "",
    type: sharedData.DashboardType,
    status: sharedData.DashboardStatus,
    statusDays: sharedData.DashboardStatusDays,
    followDay: sharedData.DashboardFollowDays,
  });
  const [AssigneeData, setAssigneeData] = useState(dropDowData.AssigneeList);

  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo.value !== "") {
      setFilterData((prevData) => ({
        ...prevData,
        assigneeValue: userInfo,
      }));
    }

    LoadQuickFilters(userInfo.value, "", "");
  }, []);

  const SortedData = useMemo(
    () =>
      [...(AssigneeData || [])].sort((a, b) => {
        if (a.active === "Y" && b.active !== "Y") {
          return -1;
        }
        if (a.active !== "Y" && b.active === "Y") {
          return 1;
        }
        return 0;
      }),
    [AssigneeData]
  );

  const ItemRender = (li, itemProps) => {
    const { dataItem, selected } = itemProps;
    const combinedClassName = `${li.props.className} ${dataItem.active === "N" ? "bg-yellow-500" : ""
      }`;
    const combinedClassName1 = `${li.props.className} ${selected ? "bg-gray-400" : ""
      }`;

    return React.cloneElement(li, {
      className: `${combinedClassName} ${combinedClassName1}`,
    });
  };
  const LoadQuickFilters = async () => {
    try {
      let queryParams = null;
      queryParams = new URLSearchParams({
        teamName: searchFilter.team ?? "",
        assigneeName: searchFilter.assignee ?? "",
        status: searchFilter.status ?? "",
        statusDays: searchFilter.statusDays ?? "",
        followUpDays: searchFilter.followDays ?? "",
        type: searchFilter.type ?? "",
      }).toString();

      document.getElementById("loader").style.display = "block";

      const url = `${BASE_HANDLER_URL}?class=HOME&action=LOADQUICKDASHBOARD&${queryParams ? `${queryParams}` : ""
        }`;

      const result = await fetch(url);
      const response = await result.json();
      if (response.status) {
        setCount((prevInfo) => ({
          ...prevInfo,
          todayCount: response.todayCount,
          overDueCount: response.overDueCount,
          statusCount: response.statusCount,
          followUpCount: response.followUpCount,
          responseTime: response.averageResponseTime,
          resolvingTime: response.averageResolvingTime,
        }));
      } else if (
        response?.status === false &&
        response?.Message ===
        "Collection was modified; enumeration operation may not execute."
      ) {
        LoadQuickFilters();
      } else {
        DisplayMsg("2", response.Message);
      }
      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const FieldValue = (fieldName) => {
    const fieldValue =
      FilterData[fieldName] != null ? FilterData[fieldName] : "";
    return fieldValue;
  };

  const FieldData = (textField, type) => {
    const curName = textField.fieldName;
    const curValue = textField.fieldValue;
    if (curName === "teamValue") {
      dropDowData.TeamsList.forEach((team) => {
        if (team.value.toString() === curValue) {
          setFilterData((taskData) => ({
            ...taskData,
            teamValue: team.value,
            teamName: team.label,
            teamEmail: team.email,
          }));
          return;
        }
        searchFilter.team = curValue;
        dispatch(setTeam(curValue));
      });
    } else if (curName === "assigneeValue") {
      dropDowData.AssigneeList.forEach((item) => {
        if (item.value === curValue) {
          setFilterData((taskData) => ({
            ...taskData,
            assigneeName: item.lable,
            assigneeValue: item.value,
          }));
        }
      });
    } else if (curName === "statusDays") {
      setFilterData((prevInfo) => ({
        ...prevInfo,
        [curName]: curValue,
      }));
      searchFilter.statusDays = curValue;
      dispatch(setStatusDays(curValue));
    } else if (curName === "followDay") {
      setFilterData((prevInfo) => ({
        ...prevInfo,
        [curName]: curValue,
      }));
      searchFilter.followDays = curValue;
      dispatch(setStatusDays(curValue));
    } else if (curName === "status") {
      setFilterData((prevInfo) => ({
        ...prevInfo,
        [curName]: curValue,
      }));
      searchFilter.status = curValue;
      dispatch(setStatus(curValue));
    } else {
      setFilterData((prevInfo) => ({
        ...prevInfo,
        [curName]: curValue,
      }));
      searchFilter.type = curValue;
      dispatch(setType(curValue));
    }
    LoadQuickFilters();
  };

  const TodayDeadLine = () => {
    if (Count.todayCount) {
      dispatch(
        setTicketTaskAllFilters({
          type: FilterData.type,
          status: "TD",
          assignee:
            FilterData.assigneeValue?.text === "-Select-"
              ? ""
              : FilterData.assigneeValue?.text || "",
          team: FilterData.teamValue,
          targetDate: new Date().toLocaleDateString(),
          currentPage: 1,
        })
      );
      dispatch(setCurrentTab("tickets"));
      dispatch(setQuickSearch(false));
      navigate("/tickets");
    }
  };

  const TicketOverDue = () => {
    if (Count.overDueCount > 0) {
      dispatch(
        setTicketTaskAllFilters({
          type: FilterData.type,
          status: "OD",
          assignee:
            FilterData.assigneeValue?.text === "-Select-"
              ? ""
              : FilterData.assigneeValue?.text || "",
          overDue: "Y",
          team: FilterData.teamValue,
          currentPage: 1,
        })
      );
      dispatch(setCurrentTab("tickets"));
      dispatch(setQuickSearch(false));

      navigate("/tickets");
    }
  };

  const ShowCountData = () => {
    if (Count.statusCount > 0) {
      dispatch(
        setTicketTaskAllFilters({
          type: FilterData.type,
          status: FilterData.status === "I" ? "P" : FilterData.status,
          assignee:
            FilterData.assigneeValue?.text === "-Select-"
              ? ""
              : FilterData.assigneeValue?.text || "",
          team: FilterData.teamValue,
          statusDays: FilterData.statusDays,
          currentPage: 1,
        })
      );

      dispatch(setCurrentTab("tickets"));

      dispatch(setQuickSearch(false));

      navigate("/tickets");
    }
  };

  const ShowFollowUpData = () => {
    if (Count.followUpCount > 0) {
      dispatch(
        setTicketTaskAllFilters({
          type: FilterData.type,
          status: "FU",
          assignee:
            FilterData.assigneeValue?.text === "-Select-"
              ? ""
              : FilterData.assigneeValue?.text || "",
          team: FilterData.teamValue,
          followDays: FilterData.followDay,
          currentPage: 1,
        })
      );
      dispatch(setCurrentTab("tickets"));
      dispatch(setQuickSearch(false));

      navigate("/tickets");
    }
  };

  const AlterAssignee = (filter) => {
    const data = dropDowData.AssigneeList.slice();
    return filterBy(data, filter);
  };
  const AlterAssigneeData = (event) => {
    let updatedAssignee = [];
    const newAssignee =
      event.filter.value.length > 1
        ? AlterAssignee(event.filter)
        : dropDowData.AssigneeList.slice();
    updatedAssignee = [...new Set(newAssignee)];
    setAssigneeData(updatedAssignee);
  };

  const AlterComboBoxData = (event) => {
    const curVal = event.target.value;
    const fieldName = event.target.name;

    const assigneeName = curVal !== null ? curVal.text : "";
    const assigneeValue = curVal !== null ? curVal.value : "";

    dispatch(setUserEmail(assigneeValue));
    dispatch(setUserName(assigneeName));

    searchFilter.assignee = assigneeValue;

    setFilterData((prevData) => ({
      ...prevData,
      [fieldName]: curVal,
      assigneeName: curVal == null ? "" : curVal,
    }));
    LoadQuickFilters();
  };

  return (
    <>
      <div className="row table-panel-header mb-2">
        <div className="col-md-12 col-sm-12">
          <h6>Quick Filters</h6>
        </div>
      </div>
      <div className="row">
        <div className="row quickFilter">
          <div className="row mb-3">
            <div className="col-auto flex">
              <label className="align-items-center flex m-0 font-medium gap-2">
                {" "}
                Assignee{" "}
              </label>
              <div className="ml-2">
                <ComboBox
                  className="field-input custom-combobox"
                  data={SortedData}
                  value={
                    FieldValue("assigneeValue") === ""
                      ? null
                      : FieldValue("assigneeValue")
                  }
                  name="assigneeValue"
                  popupSettings={{
                    className: "custom-dropdownDetail",
                  }}
                  style={{
                    width: "180px",
                    height: "25px",
                  }}
                  textField="text"
                  filterable
                  itemRender={ItemRender}
                  onFilterChange={AlterAssigneeData}
                  onChange={AlterComboBoxData}
                />
              </div>
            </div>
            <div className="col-auto">
              <label className="align-items-center flex m-0 font-medium gap-3 quickBox">
                {" "}
                Team
                <DropDownField
                  id="teamValue"
                  bold
                  classDiv
                  label={false}
                  required={false}
                  options={dropDowData.TeamsList}
                  value={FieldValue("teamValue")}
                  ReceivedTextData={FieldData}
                />
              </label>
            </div>
            <div className="col-auto">
              <label className="align-items-center flex m-0 font-medium gap-3">
                {" "}
                Type
                <DropDownField
                  id="type"
                  bold
                  classDiv
                  label={false}
                  required={false}
                  options={TICKET_TASK_FILTERS.FILTER_TYPES}
                  value={FieldValue("type")}
                  ReceivedTextData={FieldData}
                />
              </label>
            </div>
          </div>

          <div
            className="row col-auto"
            style={{ display: "flex", marginBottom: "1rem" }}
          >
            <div className="col-auto">
              <div className="col-auto py-1">
                <p>Today's Deadline</p>
              </div>

              <div className="col-auto py-1">
                <p>Tickets Overdue</p>
              </div>

              <div className="col-auto py-1">
                <p>Average First Response Time (MTD)</p>
              </div>

              <div className="col-auto py-1">
                <p>Average Resolving Time (MTD) </p>
              </div>

              <div className="col-auto py-2">
                <p className="align-items-center flex m-0 gap-2">
                  Total
                  <span
                    className="font-semibold text-900 quickSelectBox"
                    style={{ marginTop: "-10px" }}
                  >
                    <DropDownField
                      id="status"
                      bold
                      label={false}
                      classDiv
                      required={false}
                      options={DASHBOARD_FILTERS.QUICK_STATUS_OPTIONS}
                      value={FieldValue("status")}
                      ReceivedTextData={FieldData}
                    />
                  </span>
                  in Last
                  <span
                    className="quickSelectBox"
                    style={{ marginTop: "-10px" }}
                  >
                    <DropDownField
                      id="statusDays"
                      bold
                      label={false}
                      classDiv
                      required={false}
                      options={DASHBOARD_FILTERS.QUICK_STATUS_DAYS_OPTIONS}
                      value={FieldValue("statusDays")}
                      ReceivedTextData={FieldData}
                    />
                  </span>
                </p>
              </div>

              <div className="col-auto py-3">
                <p className="align-items-center flex m-0 gap-2">
                  {" "}
                  Client follow-up not get Last
                  <span
                    className="ml-1 quickSelectBox"
                    style={{ marginTop: "-10px" }}
                  >
                    <DropDownField
                      id="followDay"
                      label={false}
                      bold
                      classDiv
                      required={false}
                      options={DASHBOARD_FILTERS.QUICK_STATUS_DAYS_OPTIONS}
                      value={FieldValue("followDay")}
                      ReceivedTextData={FieldData}
                    />
                  </span>
                </p>
              </div>
            </div>

            <div className="col-auto">
              <div className="col-auto py-1">
                <p
                  className="listNumber text-sm underline cursor-pointer pr-8"
                  style={{ color: "#218838" }}
                  onClick={() => TodayDeadLine()}
                >
                  {Count.todayCount} Counts
                </p>
              </div>

              <div className="col-auto py-1">
                <p
                  className="cursor-pointer listNumber text-sm underline pr-8"
                  style={{ color: "#218838" }}
                  onClick={() => TicketOverDue()}
                >
                  {Count.overDueCount} Counts
                </p>
              </div>

              <div className="col-auto py-1">
                <p className="text-sm pr-8" style={{ color: "#218838" }}>
                  {Count.responseTime !== ""
                    ? Count.responseTime
                    : "days ( hours)"}
                </p>
              </div>

              <div className="col-auto py-1">
                <p className="text-sm pr-8" style={{ color: "#218838" }}>
                  {Count.resolvingTime !== ""
                    ? Count.resolvingTime
                    : "days ( hours)"}
                </p>
              </div>

              <div className="col-auto py-1">
                <p
                  className="cursor-pointer listNumber text-sm underline pr-8"
                  style={{ color: "#218838" }}
                  onClick={() => ShowCountData()}
                >
                  {Count.statusCount} Counts
                </p>
              </div>

              <div className="col-auto py-1">
                <p
                  className="cursor-pointer listNumber text-sm underline pr-8"
                  style={{ color: "#218838" }}
                  onClick={() => ShowFollowUpData()}
                >
                  {Count.followUpCount} Counts
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickFilter;
